import { i18n } from '@lingui/core'
import { I18nProvider } from '@lingui/react'
import { useRouter } from 'next/router'
import React, { useEffect, useRef, useState } from 'react'

import { updateLocale } from './helpers'

import type { Messages } from '@lingui/core'

import { IS_PROD } from '@/helpers/env'

/**
 * 分离到 @loc/i18n 中可能导致 @lingui/react 不一致的问题，
 * 还有编译报错 TypeError: Cannot destructure property 'i18n' of '(0 , e.useLingui)(...)' as it is null.
 * 可能收到 transpilePackages 的影响。
 */
export default function LinguiI18nProvider({
  translation,
  locale,
  children,
}: {
  translation?: Messages
  locale?: string
  children: React.ReactNode
}) {
  const router = useRouter()
  const mergedLocale = locale || router.locale || 'en'
  const loadedRef = useRef<{
    locale: string
    data: Record<string, 1>
  }>({
    locale: '',
    data: {},
  })
  const loadKey = router.pathname

  useEffect(() => {
    if (!IS_PROD) {
      (window as any)._i18n = i18n
    }
  }, [])

  // 切换语言重置 loadedRef
  if (loadedRef.current.locale !== mergedLocale) {
    loadedRef.current.locale = mergedLocale
    loadedRef.current.data = {}
  }

  useState(() => {
    updateLocale(mergedLocale, translation)
  })

  useEffect(() => {
    if (!loadedRef.current.data[loadKey]) {
      updateLocale(mergedLocale, translation)
      loadedRef.current.data[loadKey] = 1
    }
  }, [loadKey, mergedLocale, translation])

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>
}
